import { FaqModel } from "@edp-models/faq.model";
import { FaqModelES } from "./es-faq.model";
import { InterventionModelES } from "./es-intervention.model";

export class ServiceES {
    constructor(
        public acronym: string,
        public description: string,
        public name: string,
        public id: string,
        public childs: ServiceES[],
        public isSelected: boolean = false,
        public intervention?: InterventionModelES,
        public externalCategory: string = null,
        public selfcare: string = null,
        public action: string = null,
        public actionLink: string = null,
        public typeRoute: string = null,
        public category: string = null,
        public type: string = null,
        public subtype: string = null,
        public subtypeAcronym: string = null,
        public route: string = null,
        public faqs?: FaqModel[]
    ) {}
}
export class ServiceFactoryES {
    static create(service: any): ServiceES {
        return new ServiceES(
            service.acronym,
            service.description,
            service.name,
            service.id,
            service.childs,
            service.isSelected,
            service.intervention,
            service.externalCategory,
            service.selfcare,
            service.action,
            service.actionLink,
            service.typeRoute,
            service.category,
            service.type,
            service.subtype,
            service.subtypeAcronym,
            service.route,
            service.faqs
        );
    }
}
